import xf1 from "../../assets/images/1.png";
import xf2 from "../../assets/images/2.png";
import xf3 from "../../assets/images/3.png";
export const btnData = [
  {
    value: "要求解决某事",
    bgColor: "#F8E7F9",
    push: "/slovethings",
    url: xf1,
    applyType: "01",
  },
  {
    value: "不同意某处理决定",
    bgColor: "#DAF0FC",
    push: "/slovethings",
    url: xf2,
    applyType: "02",
  },
  {
    value: "反映某人或某单位违法违纪问题",
    bgColor: "#FFEFE6",
    push: "/vocation",
    url: xf3,
    applyType: "03",
  },
];
